import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=2ae18300&scoped=true"
import script from "./PaymentLink.vue?vue&type=script&lang=js"
export * from "./PaymentLink.vue?vue&type=script&lang=js"
import style0 from "./PaymentLink.vue?vue&type=style&index=0&id=2ae18300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae18300",
  null
  
)

export default component.exports